// extracted by mini-css-extract-plugin
module.exports = {"dialog":"OneClickSchedulePreview_dialog__UdWHh","content":"OneClickSchedulePreview_content__yRoPd","footer":"OneClickSchedulePreview_footer__2GuD_"};